import React ,{useRef} from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';

import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import ajaxGet from 'src/services/ajaxGet';
import ajaxPost from 'src/services/ajaxPost';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';

function EnhancedTableHead(props) {

	const { t } = useTranslation();

const headCells_CLASSIFICATION_GROUP = [
	{
		id: 'Aktionen',
		numeric: false,
		disablePadding: false,
		label: t('manageOrganization.organization.actions')
	},
	{ id: 'outputChannelName', numeric: false, disablePadding: false, label:  t('outputChannel.outputChannelName') },
	{
		id: 'id',
		numeric: false,
		disablePadding: false,
		label:  t('outputChannel.id') 
	}
];
	return (
		<>
			<TableHead>
				<TableRow>
					{headCells_CLASSIFICATION_GROUP.map((headCell, index) => (
						<TableCell
							key={index}
							align={headCell.numeric ? 'right' : 'left'}
						>
							{headCell.label}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		</>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	onRequestSort: PropTypes.func.isRequired
};

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiTableCell-head': {
			backgroundColor: '#a9a9a975',
			fontSize: '1.5rem',
			fontWeight: 'bold'
		},
		'& .MuiTableCell-body': {
			fontSize: '1.5rem'
		},
		width: '100%',
		'& .MuiSvgIcon-root': { fontSize: '3rem !important' }
	},
	paper: {
		width: '100%',
		marginBottom: theme.spacing(2)
	},
	table: {
		minWidth: 750,
		'& .MuiTableCell-root': {
			borderLeft: '1px solid rgba(224, 224, 224, 1)'
		}
	},
	deleteBtn: {
		color: 'rgb(237 14 14 / 89%) !important'
	},
	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1
	}
}));


export default function EnhancedTableOutputChannel({
	outputChannels,
	setInitFormOutputChannelState,
	setOutputChannels,
	searchOutputChannels,
	setToCreateOutputChannel,
	setContentLangSelections,
	handleClickOpenDialogOutputChannel
}) {
	const classes = useStyles();
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState('company');
	
	const { t } = useTranslation();

	const formikRef = useRef();


	const [contentLang, setContentLang] = React.useState(t('language.code'));

	const confirmDeleteOutputChannel = (id) => {
		TOGO.popupManager.confirmZebraDialog(
			t('outputChannel.deleteButtonConfirm'),
			deleteOutputChannel,
			id
		);
	};

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const deleteOutputChannel = (id) => {
		var pojo = new Object();
		pojo.outputChannelId = id;
		ajaxPost('outputchannelsManagement/delete', pojo).then((ajaxData) => {
			if (!ajaxData.error && ajaxData.response) {
				setOutputChannels(outputChannels.filter((org) => org.id !== id));
				TOGO.Util.notifyResponse(ajaxData.response.message, false);
				searchOutputChannels();
			}
		});
	};


	const editOutputChannel= (id) => {
		var contentLang = t('language.code');
		ajaxGet('outputchannelsManagement/edit', {
			outputChannelId: id,
			contentLang:contentLang
		}).then((ajaxData) => {
			if (!ajaxData.error && ajaxData.response) {
				var res = ajaxData.response.articleDataOutputChannelPojo;
				var contentLangSelections = ajaxData.response.model.contentLangSelections;

				if (res != null && res != undefined) {
					var outputChannelForm = {
						id: id,
						language:contentLang,
						outputChannelName: res?.outputChannelName || '',
					};
					setContentLangSelections(contentLangSelections);
					setInitFormOutputChannelState(outputChannelForm);
					setToCreateOutputChannel(false);
					handleClickOpenDialogOutputChannel();
				}
			}
		});
	};
	return (
		<div className={classes.root}>
			{ outputChannels.length > 0 ? (
				<Paper className={classes.paper}>
					<TableContainer>
						<Table
							className={classes.table}
							aria-labelledby="tableTitle"
							aria-label="simple table"
						>
							<EnhancedTableHead
								classes={classes}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
								<TableBody>
									{outputChannels.map((row, index) => {
										return (
											<TableRow hover role="checkbox" tabIndex={-1} key={index}>
												<TableCell align="center">
													<Grid container >
													<Grid item xs={6}>
															<Tooltip
																title={
																	<Typography fontSize={5}>{t('common.edit')}</Typography>}>
																<IconButton
																	onClick={() => {
																		editOutputChannel(row.id);
																	}}
																>
																	<EditIcon />
																</IconButton>
															</Tooltip> 
														</Grid>
														<Grid item>
														<Tooltip
														title={
															<Typography fontSize={5}>{t('outputChannel.deleteButton')}</Typography>
														}
													>
														<IconButton
															onClick={() => {
																confirmDeleteOutputChannel(row.id);
															}}
														>
															<DeleteIcon className={classes.deleteBtn} />
														</IconButton>
													</Tooltip>
														</Grid>
													</Grid>
												</TableCell>
												<TableCell align="left">
												{row.outputChannel}
												</TableCell>
												<TableCell align="left">
												{row.id}
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
						</Table>
					</TableContainer>{' '}
				</Paper>
			) : (
				<Typography
					paragraph={true}
					noWrap={false}
					fontWeight={'bold'}
					align="center"
					fontSize={20}
				>
					{t('common.noSearchResults')}
				</Typography>
			)}
		</div>
	);
}

